const isNumeric = (n) => {

    return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
    
}

export default isNumeric;